import { useQuery } from '@tanstack/react-query';
import { v4 as uuidv4 } from 'uuid';

const BFF_BASE_URL = process.env.REACT_APP_BFF_BASE_URL

export async function getDirectDebitConsent(session: any) {
    if(!session?.accessToken || session?.expiryMs < Date.now()) {
        throw new Error('Session expired')
    }
    const res = await fetch(`${BFF_BASE_URL}/v1/directDebit/consent`,
        {
            method: 'GET',
            // body: JSON.stringify({ siteId, timezone, date }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${session?.accessToken}`,
                'x-id': `${session?.idToken}`,
                'x-session-id': session?.sessionId || 'x-session-id',
                'x-correlation-id': uuidv4()
            }
        }
    );
    
    if (!res.ok) {
        throw new Error((await res.json()).message);
    }
    return (await res.json())
}

export async function getDirectDebitBankByNumber(
        session: any, number: string
    ) {
    if(!session?.accessToken || session?.expiryMs < Date.now()) {
        throw new Error('Session expired')
    }
    if(!number || number.length<2) return null;
    const res = await fetch(`${BFF_BASE_URL}/v1/directDebit/bank/number`,
        {
            method: 'POST',
            body: JSON.stringify({ number }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${session?.accessToken}`,
                'x-id': `${session?.idToken}`,
                'x-session-id': session?.sessionId || 'x-session-id',
                'x-correlation-id': uuidv4()
            }
        }
    );
    
    if (!res.ok) {
        throw new Error((await res.json()).message);
    }
    return (await res.json())
}


export async function getDirectDebitBankInfo(
        session: any, number: string, branch: string
    ) {
    if(!session?.accessToken || session?.expiryMs < Date.now()) {
        throw new Error('Session expired')
    }
    if(!number || !branch || branch.length < 4) return null;
    const res = await fetch(`${BFF_BASE_URL}/v1/directDebit/bank/info`,
        {
            method: 'POST',
            body: JSON.stringify({ number, branch }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${session?.accessToken}`,
                'x-id': `${session?.idToken}`,
                'x-session-id': session?.sessionId || 'x-session-id',
                'x-correlation-id': uuidv4()
            }
        }
    );
    
    if (!res.ok) {
        throw new Error((await res.json()).message);
    }
    return (await res.json())
}

export async function updateDirectDebitBank(
        session: any, bank: any
    ) {
    if(!session?.idToken || session?.expiryMs < Date.now()) {
        throw new Error('Session expired')
    }
    const res = await fetch(`${BFF_BASE_URL}/v1/directDebit/bank`,
        {
            method: 'POST',
            body: JSON.stringify({ bank }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${session?.accessToken}`,
                'x-id': `${session?.idToken}`,
                'x-session-id': session?.sessionId || 'x-session-id',
                'x-correlation-id': uuidv4()
            }
        }
    );
    
    if (!res.ok) {
        throw new Error((await res.json()).message);
    }
    return (await res.json())
}

export const useGetDirectDebitBankByNumber = (number: string, session: any) => {
    const { data: bank } = useQuery({
        queryKey: ['BankByNumber', number], // key must be unique
        queryFn: ()=>getDirectDebitBankByNumber(session, number),
        staleTime: (60000 * 600),
        retry: false
    })
    return { bank }
};

export const useGetDirectDebitBankInfo = (
        number: string, branch: string, session: any
    ) => {
    const { data: bankInfo } = useQuery({
        queryKey: ['BankByNumber', number, branch], // key must be unique
        queryFn: ()=>getDirectDebitBankInfo(session, number, branch),
        staleTime: (60000 * 600),
        retry: false
    })
    return { bankInfo }
};


export const useGetDirectDebitConsent = (session: any) => {
    const { data: consent } = useQuery({
        queryKey: ['DirectDebitConsent'], // key must be unique
        queryFn: ()=>getDirectDebitConsent(session),
        staleTime: (60000 * 600)
    })
    return { consent }
};


